import { useContext } from 'react'
import { BrandingContext, type BrandingContextValue } from './BrandingContext'

// Liefert appName (mit Fallback), logo und isLoading. Ohne Provider greift der
// neutrale Default-Context (APP_NAME, kein Logo), sodass Konsumenten nie werfen.
export function useBranding(): BrandingContextValue {
  return useContext(BrandingContext)
}
